import type { VersionedAssetFragment } from '@frameio/graphql-client/generated';

/**
 * Return if the asset is a version within a version stack.
 *
 * @returns  boolean
 */
export const isVersionInStack = (
  item: Pick<VersionedAssetFragment, 'parent'>
) => item?.parent?.__typename === 'VersionStackAsset' || false;
